<template>
  <form-group :validator="v" :label="$t('city')">
    <input 
      type="text" 
      class="input"
      v-model="cityName"
      :placeholder="$t('addCity')"
       @input="v.$touch()"
        />
  </form-group>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    v: {
      type: Object,
      required: true
    }
  },
  computed: {
    cityName: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
